import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PropertiesPage from "./pages/PropertiesPage";
import BookingsPage from "./pages/BookingsPage";
import EarningsPage from "./pages/EarningsPage";
import AIReportsPage from "./pages/AIReportsPage";
import DocumentsPage from "./pages/DocumentsPage";
import OwnersPage from "./pages/OwnersPage";
import CostsPage from "./pages/CostsPage";
import AppLayout from "./components/AppLayout";
import "./App.css";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-muted border-t-foreground" />
      </div>
    );
  }
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="proprieta" element={<PropertiesPage />} />
        <Route path="prenotazioni" element={<BookingsPage />} />
        <Route path="guadagni" element={<EarningsPage />} />
        <Route path="costi" element={<CostsPage />} />
        <Route path="documenti" element={<DocumentsPage />} />
        <Route path="proprietari" element={<OwnersPage />} />
        <Route path="report-ai" element={<AIReportsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
